import { createApp } from 'vue'

import SignInApp from 'components/signin/SignInApp.vue'
import comm from 'Modules/comm'
import pinia from 'client/stores'
import router from 'components/signin/router'
import logdna from 'Modules/browser-logger'

import hasFeature from 'client/plugins/hasFeature'
import i18n from 'client/plugins/i18n'

import '@ui/styles/src/scss/core/custom.scss'
import '@ui/styles/src/css/fonts.css'

import '@ui/styles/src/scss/pages/signin.scss'

import { svgSpriteDirectivePlugin } from 'client/plugins/svg-sprite'
import '@ui/styles/src/css/bootstrap-vue.css'

comm.init('', pinia.state.value.__csrfToken)
logdna.init(pinia)

const app = createApp(SignInApp)
  .use(router)
  .use(pinia)
  .use(svgSpriteDirectivePlugin, { url: '' })

app.use(i18n)
app.use(hasFeature)

app.mount('#signin-app-vue')
